if (!customElements.get('free-delivery-bar')) {
  customElements.define(
    'free-delivery-bar',
    class FreeDeliveryBar extends HTMLElement {
      constructor() {
        super();
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.currency = this.dataset.currency || 'GBP';
        this.fill = this.querySelector('[data-fdb-fill]');
        this.message = this.querySelector('[data-fdb-message]');
        this.track = this.querySelector('[role="progressbar"]');
      }

      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.cartUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const total = event?.cartData?.total_price ?? event?.cartData?.totalPrice;
          if (typeof total === 'number') {
            this.update(total);
          } else {
            // Some publishers (e.g. Dawn's product-form) pass the /cart/add.js
            // response, which has no total_price — fetch the real cart total.
            this.fetchCartTotal();
          }
        });
      }

      async fetchCartTotal() {
        try {
          const res = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', {
            headers: { Accept: 'application/json' },
          });
          if (!res.ok) return;
          const cart = await res.json();
          if (typeof cart.total_price === 'number') this.update(cart.total_price);
        } catch (_e) {
          /* network hiccup — keep last known state */
        }
      }

      disconnectedCallback() {
        this.cartUnsub?.();
      }

      formatMoney(pence) {
        try {
          return new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: this.currency,
            currencyDisplay: 'symbol',
          }).format(pence / 100);
        } catch (_e) {
          return `£${(pence / 100).toFixed(2)}`;
        }
      }

      update(totalPence) {
        if (!this.threshold) return;
        const remaining = Math.max(this.threshold - totalPence, 0);
        const pct = Math.min((totalPence / this.threshold) * 100, 100);
        if (this.fill) this.fill.style.width = `${pct}%`;
        if (this.track) this.track.setAttribute('aria-valuenow', String(Math.round(pct)));
        if (this.message) {
          this.message.innerHTML =
            remaining > 0
              ? `Spend <strong>${this.formatMoney(remaining)}</strong> more for <strong>FREE UK delivery</strong>`
              : `<strong>You qualify for FREE UK delivery</strong>`;
        }
      }
    }
  );
}
